import React from 'react'
import { ActivityIndicator, View } from 'react-native'

/**
 * The loading indicator used throughout the app. A wrapper for the react-native ActivityIndicator.
 * @component
 */
export const Loading = () => {
  return (
    <View style={{position: 'absolute', width: '100%', height: '100%', flex: 1, justifyContent: 'center'}}>
      <ActivityIndicator />
    </View>
  )
}
